//
// UtilityService
//      getVersionFeature
//          input - feature to be tested for version inclusion
//          return - true/feature included in product version
//                   false/feature not included in product version
//
export function utilityServiceFactory(reportdata, config) {

    'ngInject';

    var resultString = reportdata.resultString;
    var sampleDetails = reportdata.sampleDetails;
    var productVersion = sampleDetails.productVersion == '' ? '2.0' : sampleDetails.productVersion;
    $(document).ready(function(){
        $('[data-toggle="tooltip"]').tooltip();   
    });
    
    String.prototype.replaceAll = function(s, r) {
        return this.split(s).join(r)
    }
    
    return {
        getVersionFeature: function(feature) {

            var featureEnabled = true;
            var traits = resultString.traits;

            if (feature == "Traits") {
                // don't show Traits pulldown, or allow traversal to traits, if no data in traits array
                if (traits === undefined || traits.length == 0) {
                    featureEnabled = false;
                }
            }

            return featureEnabled && config.productfeatures[productVersion].indexOf(feature) >= 0;
        },
        getProductVersion: function() {


           return productVersion
        },
        formatDate: function(date) {
            var monthNames = [
              "January", "February", "March",
              "April", "May", "June", "July",
              "August", "September", "October",
              "November", "December"
            ];

            //var date = new Date(date);
            var formatedDate=date.substring(0, 10);
            var splitdate = formatedDate.split("-");
            //var date1 = "2012-12-31".split("-");
            var your_date = new Date(splitdate[0], splitdate[1]-1, splitdate[2]);
            return  monthNames[your_date.getMonth()] + ' '+ your_date.getDate() +', ' + your_date.getFullYear();

        },
        fbs_click: function() {
            var myImage = document.getElementById('certificate'); // or whatever means of access
            var src = myImage.src; // will contain the full path
            window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(src)+'&t='+encodeURIComponent(src)+ '&title=Check out my Wisdom Panel Doggie DNA results! #WisdomPanelAmbassadors', 'sharer', 'toolbar=0,status=0,width=626,height=436');
            return false;
        },
        instagram_click: function() {
            var myImage = document.getElementById('certificate'); // or whatever means of access
            var src = myImage.src; // will contain the full path
            window.open("https://instagram.com/wisdompanel?url=" + escape(src) + "&text=" + document.title + '&media=' + encodeURIComponent(src), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            return false;
        },
        twitter_click: function() {
            var myImage = document.getElementById('certificate'); // or whatever means of access
            var src = myImage.src; // will contain the full path
            window.open('https://twitter.com/intent/tweet?url=' + src, "status = 1, toolbar=0,status=0,width=626,height=436");
            return false;
        },
        pinterest_click: function() {
            var myImage = document.getElementById('certificate'); // or whatever means of access
            var src = myImage.src; // will contain the full path
            window.open('http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(src) + '&media=' + encodeURIComponent(src) + '&t=' + encodeURIComponent(src), "status = 1, toolbar=0,status=0,width=626,height=436");
            return false;
        },
        printCertificate: function() {
        	var ua = window.navigator.userAgent;
        	var msie = ua.indexOf("MSIE ");
        	var printCertificatePath= "/staticresources/dnareports/images/" + resultString.sampleID + "/certificate.png";
        	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
        	{
	        	var myWindow=window.open('','','width=100%,height=100%');
	            myWindow.document.write('<img src="' + printCertificatePath + '" height="100%" width="100%"/>');
	            myWindow.document.close();
		        myWindow.focus();
		        myWindow.print();
		        myWindow.close();
        	}else{
        		var win = window.open('');
            	win.document.write('<img src="' + printCertificatePath + '" onload="window.print();window.close()" height="150%" width="100%"/>');
            	win.focus();	
        	}
        }
    };
}

export default angular.module('mars.vet.services.utility',[]).factory('UtilityService', utilityServiceFactory).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/utility.service.js